import pc from 'picocolors';

const GHOST = String.raw`
   .-"""-.
  /  o o  \      ghosty
  |   ^   |      deploy apps without the scary parts
  |  '-'  |
  '~,~,~,~'
`;

export function printBanner(productNameValue: string): void {
  process.stdout.write(pc.cyan(GHOST));
  if (productNameValue && productNameValue !== 'Ghosty') {
    process.stdout.write(pc.dim(`   signed in to ${productNameValue}\n`));
  }
  process.stdout.write('\n');
}
